import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultPincodeData = {
  id: 0,
  enabled: true,
  countryId: undefined,
  country: {
    id: null
  },
  stateId: undefined,
  state: {
    id: null
  },
  cityId: undefined,
  city: {
    id: null
  },
  pincode: '',
  pincodeName: ''
};
export const getPincodes = params => request({
  url: '/pincodes',
  method: 'get',
  params
});
export const getPincodeById = id => request({
  url: `/pincodes/${id}`,
  method: 'get'
});
export const updatePincode = (id, data) => request({
  url: `/pincodes/${id}`,
  method: 'patch',
  data
});
export const deletePincode = id => request({
  url: `/pincodes/${id}`,
  method: 'delete'
});
export const createPincode = data => request({
  url: '/pincodes/',
  method: 'post',
  data
});